<template>
    <div class="phoneVerificationCodeInputbox" :style="containerStyle">
        <input class="inputbox" type="text" v-model="verifyCode" :placeholder="placeholder" :required="required"
           @input="$emit('input', $event.target.value)" @change="onChangeVerifyCode"/>
        <button class="sendButton" @click="getVerifyCode()" type="button" :disabled="phone.length < 1">
            <span v-if="verifyCodeSeconds == 0">获取验证码</span>
            <span v-if="verifyCodeSeconds">{{verifyCodeSeconds}}S</span>
        </button>
    </div>
</template>

<script>
// util and platformApi
import appHelper from "@util/appHelper";
import objectHelper from "@util/objectHelper";
import requestManager from "@comp/platformApi/requestManager";
import timerManager from "@comp/platformApi/timerManager";

const config = {
    // unit: second
    verifyCodeSendDelay : 60,

    apiConfig : {
        sendMsgVerifyCode : {
            url: 'login/sendMsgVerifyCode',
            method: 'post',
        }
    }
};

export default {
    name: "phoneVerificationCodeInputbox",
    props : {
        containerStyle : Object,
        inputboxStyle : Object,
        buttonStyle : Object,
        phone : String,
        placeholder : String,
        required : Boolean,
        length : {
            type : Number,
            default : 6
        },
        value : String
    },
    data() {
        return {
            verifyCode : '',
            verifyCodeSeconds : 0,
            countDownTimer : null,
        }
    },
    methods : {
        getVerifyCode() {

            if (!this.phone)
            {
                return;
            }

            // check timer
            if (this.countDownTimer)
            {
                appHelper.showHint('验证码' + config.verifyCodeSendDelay + '秒内有效');
                return;
            }

            let sendVerifyCodeApi = objectHelper.clone(config.apiConfig.sendMsgVerifyCode);
            sendVerifyCodeApi.data = {
                phone : this.phone
            };

            requestManager.request(sendVerifyCodeApi, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                let errorCode = result.errorCode || 0;
                if (errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                appHelper.showHint('发送成功，请查收。');

                this.verifyCodeSeconds = config.verifyCodeSendDelay;
                this.countDownTimer = timerManager.setInterval(() => {
                    this.verifyCodeSeconds--;

                    if (this.verifyCodeSeconds == 0)
                    {
                        timerManager.clearInterval(this.countDownTimer);
                        this.countDownTimer = null;
                    }
                }, 1 * 1000);
            });

        },

        onChangeVerifyCode() {

            if (this.verifyCode.length > this.length)
            {
                this.verifyCode = this.verifyCode.substr(0, this.length);
            }

            this.value = this.verifyCode;
            this.$emit('change', this.value);
        },
    }
}
</script>

<style lang="scss" scoped>
.phoneVerificationCodeInputbox {
    display: inline-block;
}
.inputbox {
    color: #9D9E9D;
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    border: none;
    background: transparent;
    padding: 0;
    width: 80px;
}
.sendButton {
    color: #9D9E9D;
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    border: none;
    background: transparent;
    text-align: center;
    padding: 0;
    width: 90px;
}
</style>
